import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

import { TextSize } from './interfaces';

@Component({
  selector: 'vi-ui-compound-button',
  templateUrl: './compound-button.component.html',
  styleUrls: ['./compound-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompoundButtonComponent {
  @Input({ required: true }) title: string;
  @Input() subtitle?: string;
  @Input() titleSize?: TextSize = TextSize.Large;
  @Input() titleWeight?: number | string = '600';
  @Input() subtitleSize?: TextSize = TextSize.Large;
  @Input() titleColor?: string = 'var(--type-primary)';
  @Input() subtitleColor?: string = 'var(--type-secondary)';
  @Input() disabledTitleColor?: string = 'var(--type-disabled-alt)';
  @Input() disabledSubtitleColor?: string = 'var(--type-disabled-alt)';
  @Input({ required: true }) width: string;
  @Input({ required: true }) height: string;
  @Input() textAlign?: 'left' | 'center' | 'right' | 'auto' = 'left';
  @Input() disabled: boolean = false;
  @Input() ariaLabel?: string;

  @ContentChild('customTitle') customTitle?: TemplateRef<unknown>;
  @ContentChild('customSubtitle') customSubtitle?: TemplateRef<unknown>;

  @Output() clicked = new EventEmitter<void>();

  public onButtonClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
